import React, { useState, useEffect } from 'react'
import Container from 'react-bootstrap/Container'
import Nav from 'react-bootstrap/Nav'
import Navbar from 'react-bootstrap/Navbar'

function Header({ socials }) {
  const [isActiveMenu, setIsActiveMenu] = useState("section1")

  function handleActiveSection(event) {
    const sectionId = event.target.getAttribute('data-id')
    const element = document.getElementById("toggleMenu")
    var computedStyle = window.getComputedStyle(element);
    setIsActiveMenu(sectionId)
    if (computedStyle.display !== "none") {
      setTimeout(function () {
        element.click()
      }, 500)
    }
  }

  function handleMenuToggle() {
    var divElement = document.getElementById("header-nav");
    divElement.classList.toggle("mobile-header");
  }

  // Move scroll listener inside useEffect to avoid SSR issues
  useEffect(() => {
    // Function to get all scroll-div elements
    const getScrollDivs = () => {
      return document.querySelectorAll('.scroll-div');
    }

    // Function to get the current div's id on scroll
    function getCurrentDivId() {
      let currentDivId = null;
      let closestDistance = Infinity;
      const divs = getScrollDivs();

      divs.forEach((div) => {
        const rect = div.getBoundingClientRect();
        // Check if the element is in the viewport
        if (rect.top <= window.innerHeight && rect.bottom >= 0) {
          // Calculate distance from top of viewport
          const distance = Math.abs(rect.top);
          if (distance < closestDistance) {
            closestDistance = distance;
            currentDivId = div.id;
          }
        }
      });

      return currentDivId;
    }

    // Listen for the 'scroll' event on the window
    const handleScroll = () => {
      var currentId = getCurrentDivId();
      // Only update if we found a section
      if (currentId) {
        setIsActiveMenu(currentId)
      }
    };

    window.addEventListener('scroll', handleScroll);
    
    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []); // Empty dependency array means this runs once on mount
  
  // Instagram link - directly set to the correct URL
  const instagramLink = "https://www.instagram.com/milabysmoky/?hl=en";
  const instagramLogo = "https://sqlvas774pizbiy4km.blob.core.windows.net/liveenvironment/website/mila/elements/instagram icon.png";
  
  return (
    <>
      <style>{`
        /* Add background color to navbar */
        .navbar.bg-body-tertiary {
          background-color: #f0e7da !important;
        }
        
        /* CSS to make active navigation links dark blue without changing font */
        .nav-link-active {
          color: #00008B !important; /* Dark blue */
          border-bottom: 2px solid #00008B !important;
          font-family: inherit; /* Preserve original font */
        }
        
        /* Optional: Hover effect for active links */
        .nav-link-active:hover {
          color: #00008B !important; /* Dark blue */
          font-family: inherit; /* Preserve original font */
        }
        
        /* Style for regular nav links - preserve original font */
        .nav-link {
          color: #00008B !important; /* Dark blue */
          transition: color 0.3s ease, border-bottom 0.3s ease;
          padding-bottom: 5px;
          margin: 0 10px;
          font-family: inherit; /* Preserve original font */
        }
        
        /* Hover effect for all nav links - preserve original font */
        .nav-link:hover {
          color: #00008B !important; /* Dark blue */
          font-family: inherit; /* Preserve original font */
        }
        
        /* Ensure mobile menu links are also dark blue when active - preserve original font */
        @media (max-width: 991.98px) {
          .nav-link-active {
            color: #00008B !important; /* Dark blue */
            background-color: rgba(0, 0, 139, 0.1) !important;
            border-left: 3px solid #00008B !important; /* Dark blue */
            border-bottom: none !important;
            font-family: inherit; /* Preserve original font */
          }
          
          /* Mobile menu background */
          .navbar-collapse {
            background-color: #f0e7da !important;
          }
          
          /* On mobile, show Instagram in the collapse menu */
          .instagram-mobile {
            display: block !important;
          }
          
          .instagram-desktop {
            display: none !important;
          }
        }
        
        /* Desktop: show Instagram on the right */
        @media (min-width: 992px) {
          .instagram-mobile {
            display: none !important;
          }
          
          .instagram-desktop {
            display: flex !important;
          }
        }
        
        /* Ensure all navbar text uses the original font family */
        #header-nav,
        #header-nav .nav-link,
        #header-nav .navbar-brand,
        #header-nav .navbar-toggler {
          font-family: inherit !important;
        }
        
        /* Main container layout for desktop */
        .navbar > .container {
          display: flex;
          justify-content: space-between; /* Changed from center to space-between */
          align-items: center;
          width: 100%;
          position: relative;
        }
        
        /* Logo on the left */
        .navbar-brand-left {
          flex: 0 0 auto;
          margin-right: auto;
        }
        
        /* Center the navigation links container */
        .navbar-center-links {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          justify-content: center;
        }
        
        /* Instagram on the right */
        .navbar-instagram-right {
          flex: 0 0 auto;
          margin-left: auto;
        }
        
        /* Navigation links container */
        .nav-list {
          display: flex;
          justify-content: center;
        }
        
        /* Preserve original styles for the header logo */
        .header-logo {
          height: auto;
          max-height: 80px; /* Increased from 40px to 80px */
          width: auto;
        }
        
        /* Preserve original styles for social icon */
        .social-icon {
          height: 24px;
          width: 24px;
        }
        
        /* Ensure navbar toggler button matches the theme */
        .navbar-toggler {
          border-color: #003594 !important;
        }
        
        .navbar-toggler-icon {
          background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba(0, 53, 148, 1)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e") !important;
        }
        
        /* Mobile menu adjustments */
        @media (max-width: 991.98px) {
          .navbar > .container {
            justify-content: space-between;
          }
          
          .navbar-center-links {
            position: static;
            transform: none;
            width: 100%;
          }
          
          .navbar-brand-left,
          .navbar-instagram-right {
            position: static;
            transform: none;
          }
        }
      `}</style>
      
      <Navbar id="header-nav" expand="lg" fixed="top" className="navbar bg-body-tertiary mobile-header" style={{ backgroundColor: '#f0e7da', padding: '10px 0' }}>
        <Container>
          {/* Logo on the left */}
          <Nav className="navbar-brand-left me-0">
            <img
              src="https://sqlvas774pizbiy4km.blob.core.windows.net/liveenvironment/website/mila/elements/Mila logo.png"
              className="header-logo"
              alt="smokey logo"
              style={{ maxHeight: '80px' }}
            />
          </Nav>
          
          <Navbar.Toggle id="toggleMenu" aria-controls="basic-navbar-nav" onClick={handleMenuToggle} />
          
          {/* Instagram icon on the right (Desktop) */}
          <Nav className="navbar-instagram-right instagram-desktop">
            <Nav.Link 
              href={instagramLink} 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <img 
                src={instagramLogo} 
                alt="Instagram" 
                className="social-icon"
              />
            </Nav.Link>
          </Nav>
          
          <Navbar.Collapse id="basic-navbar-nav" className='collapse navbar-collapse d-lg-flex navbar-center-links' style={{ backgroundColor: '#f0e7da' }}>
            {/* Navigation links centered */}
            <Nav className="nav-list">
              <Nav.Link 
                href="#section1" 
                data-id="section1" 
                className={isActiveMenu === "section1" ? "nav-link-active" : ""} 
                onClick={handleActiveSection}
              >
                HOME
              </Nav.Link>
              
              <Nav.Link 
                href="#section2" 
                data-id="section2" 
                className={isActiveMenu === "section2" ? "nav-link-active" : ""} 
                onClick={handleActiveSection}
              >
                ABOUT US
              </Nav.Link>
              
              <Nav.Link 
                href="#section3" 
                data-id="section3" 
                className={isActiveMenu === "section3" ? "nav-link-active" : ""} 
                onClick={handleActiveSection}
              >
                MENU
              </Nav.Link>
              
              <Nav.Link 
                href="#section4" 
                data-id="section4" 
                className={isActiveMenu === "section4" ? "nav-link-active" : ""} 
                onClick={handleActiveSection}
              >
                LOCATION
              </Nav.Link>
              
              <Nav.Link 
                href="#section7" 
                data-id="section7" 
                className={isActiveMenu === "section7" ? "nav-link-active" : ""} 
                onClick={handleActiveSection}
              >
                CONTACT US
              </Nav.Link>
              
              {/* Instagram icon on mobile (inside collapse) */}
              <Nav className="instagram-mobile">
                <Nav.Link 
                  href={instagramLink} 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <img 
                    src={instagramLogo} 
                    alt="Instagram" 
                    className="social-icon"
                  />
                </Nav.Link>
              </Nav>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default Header;